// src/app/pages/dataedo-downloads-page/dataedo-downloads-page.component.ts
import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {DataedoDownloadsService} from '../../api/repositories/dataedo-downloads.service';
import {DataedoDownloadsModelResponse} from 'src/app/api/responses/dataedo-downloads-response';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-dataedo-downloads-page',
    templateUrl: './dataedo-downloads-page.component.html',
    styleUrls: ['./dataedo-downloads-page.component.scss'],
})
export class DataedoDownloadsPageComponent implements OnInit, OnDestroy {
    public dataedoDownloads$: Observable<DataedoDownloadsModelResponse | null>;
    private gc = new Subject();

    constructor(
        private title: Title,
        private dataedoDownloadsService: DataedoDownloadsService // Serwis do pobierania danych
    ) {
    }

    public ngOnInit(): void {
        this.title.setTitle('Dataedo downloads');

        this.dataedoDownloads$ = this.dataedoDownloadsService.getDownloads();
    }

    // Funkcja do konwertowania nazwy pliku na Base64
    public encodeFileName(fileName: string): string {
        return btoa(fileName);
    }

    public ngOnDestroy(): void {
        this.gc.next();
        this.gc.complete();
    }
}
